import AddisAbabaImagemain from '../images/addis_ababa_image_main.webp';
import baleMountainsMain from '../images/bale_mountains.webp';
import omoValleyMain from '../images/omo_valley_main.webp';
import bahirDarMain from '../images/bahir_dar_main.webp';
import lalibelaMain from '../images/lalibela_main.webp';
import tigrayMain from '../images/tigray_main.jpg';

export const destinationData = [
  {
    name: 'Addis Ababa',
    description:
      'Addis Ababa, the capital of Ethiopia, is a vibrant city rich in history and culture. Known for its museums, historical landmarks, and bustling markets, Addis offers a perfect blend of the old and new.',
    image: AddisAbabaImagemain,
    tourType: ['Cultural', 'City Tour', 'History'],
  },
  {
    name: 'Lalibela',
    description:
      "Lalibela is home to one of the world's most remarkable sites of historical and religious significance – the rock-hewn churches. These ancient structures, carved from solid rock, are a testament to Ethiopia's rich Christian heritage.",
    image: lalibelaMain,
    tourType: ['Cultural', 'Religious', 'Adventure'],
  },
  {
    name: 'Bale Mountains',
    description:
      'The Bale Mountains, located in southeastern Ethiopia, are a stunning highland region known for their diverse ecosystems, breathtaking landscapes, and rich wildlife. Home to the Bale Mountains National Park, this area features vast plateaus, dense forests, alpine meadows, and dramatic peaks, including Tullu Dimtuu, the second-highest mountain in Ethiopia.',
    image: baleMountainsMain,
    tourType: ['Adventure', 'Wildlife', 'Nature'],
  },
  {
    name: 'Bahir Dar',
    description:
      'Bahir Dar, located near the shores of Lake Tana, is known for its beautiful scenery, ancient monasteries, and the stunning Blue Nile Falls. It’s a gateway to the wonders of Northern Ethiopia.',
    image: bahirDarMain,
    tourType: ['Cultural', 'Family', 'Nature'],
  },
  {
    name: 'Omo Valley',
    description:
      'The Omo Valley is a cultural melting pot, home to numerous indigenous tribes with unique customs and traditions. Visiting the Omo Valley offers a deep dive into Ethiopia’s rich and diverse cultural heritage.',
    image: omoValleyMain,
    tourType: ['Cultural', 'Adventure', 'Photography'],
  },
  {
    name: 'Tigray',
    description:
      'Tigray is known for its stunning rock-hewn churches, dramatic mountain landscapes, and rich ancient history. The region is home to sites like the breathtaking Gheralta rock churches and the ruins of Aksum, an ancient city that was once the center of a powerful civilization.',
    image: tigrayMain,
    tourType: ['Cultural', 'Historical', 'Adventure'],
  },
];
